import React from 'react';

function AdminWhite(props) {
  return (
    <svg viewBox="0 0 28 28" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M7 7h14v14H7z" />
        <path
          d="M9.333 9.333l4.452-.834c.142-.027.288-.027.43 0l4.452.834v5.415a4.965 4.965 0 01-2.334 4.21l-2.024 1.265a.583.583 0 01-.618 0l-2.024-1.265a4.965 4.965 0 01-2.334-4.21V9.333zm4.278 8.167l2.722-3.85h-1.36v-2.567l-2.723 3.85h1.361V17.5z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default AdminWhite;
